<template>
  <div class="contents_wrapper">
    <Header
      :isHome="true"
      :btnType="'reload'"
      :now="currentNow"
      @click_header_btn="loadActiveEvent"
    />
    <div class="contents">
      <div class="home_main">
        <ul v-if="loaded && checkinEnableRooms.length && rooms" class="home_schedule">
          <li
            v-for="meeting in checkinEnableRooms"
            :key="meeting.id"
            class="home_schedule_item"
            v-bind:class="{'checkin-now' : meeting.iWasCheckin, 'checkin-wait' : !meeting.iWasCheckin }"
          >
            <a
              href="javascript:void(0)"
              @click="selectedRoom(meeting)"
              class="home_schedule_item_a"
            >
              <div v-if="meeting.iWasCheckin" class="schedule_item_left">
                <div class="item_left_icon">
                  <img :src="$designResource.homeCheckinNow" alt="チェックイン中" />
                </div>
                <div class="item_left_text">チェックイン中</div>
              </div>
              <div v-else class="schedule_item_left">
                <div class="item_left_icon">
                  <img :src="$designResource.homeCheckinWait" alt="チェックイン待ち" />
                </div>
                <div class="item_left_text">チェックイン待ち</div>
              </div>
              <div class="schedule_item_right">
                <div class="schedule_detail">
                  <MeetingInfomation
                    v-bind:time="formatDate(meeting.startDate) + '-' +  formatDate(meeting.endDate)"
                    v-bind:subject="meeting.subject"
                    v-bind:roomName="meeting.rooms.map(r => r.display).join(' ')"
                  />
                </div>
              </div>
            </a>
          </li>
        </ul>
        <div v-else-if="loaded" class="home_no-schedule">
          <div class="no-schedule_icon">
            <img :src="$designResource.homeNoSchedule" alt="予定なし" />
          </div>
          <div class="no-schedule_text">現在、対象の予定はありません。</div>
        </div>
        <div v-else class="home_no-schedule loading">読込中...</div>
      </div>
      <div class="home_bottom">
        <div class="home_bottom_btn">
          <router-link to="/time" class="home_bottom_btn_link">
            <div class="home_bottom_btn_icon">
              <img :src="$designResource.homeImasugu" alt />
            </div>
            <div class="home_bottom_btn_text">
              今すぐ予約できる
              <br />会議室を探す
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import Header from "../components/Header.vue";
import MeetingInfomation from "../components/MeetingInfomation.vue";

import Store from "../store";
import RoomService from "../services/roomService";
import RoomAttributeService from "../services/roomAttributeService";
import MeetingService from "../services/meetingService";
import TenantService from "../services/tenantService";
import loggerService from "../services/loggerService";

import status from "../models/status";

const store = new Store();

export default {
  components: {
    Header,
    MeetingInfomation
  },
  data: function() {
    return {
      currentNow: new Date(),
      loaded: false,
      checkinEnableRooms: [],
      rooms: null,
      showAlertMessage: false
    };
  },
  created: function() {
    loggerService.pageView("Main");
    var _this = this;
    TenantService.getMyTenantInfo().then(function(tenant) {
      store.tenant = tenant;
      _this.loadActiveEvent();
    });
    window.addEventListener("resume", this.loadActiveEvent, false);
  },
  beforeDestroy: function() {
    window.removeEventListener("resume", this.loadActiveEvent, false);
  },
  methods: {
    formatDate: function(date) {
      return moment(date).format("HH:mm");
    },
    showMessage: function(msg) {
      var _this = this;
      this.alartMessage = msg;
      this.showAlertMessage = true;
      setTimeout(() => {
        _this.showAlertMessage = false;
      }, 2000);
    },
    startNFC: function() {
      var ev = new Event("startScan");
      window.dispatchEvent(ev);
    },
    loadActiveEvent: function() {
      var _this = this;
      var roomsIsLoaded = false;
      var meetingIsLoaded = false;
      _this.loaded = false;
      _this.currentNow = new Date();
      _this.checkinEnableRooms = null;
      RoomAttributeService.getRoomAttributes(true);
      RoomService.getRooms(true).then(rooms => {
        _this.rooms = rooms;

        roomsIsLoaded = true;
        _this.loaded = meetingIsLoaded && roomsIsLoaded;
      });
      MeetingService.getActiveEvent(store.account, function(events) {
        _this.checkinEnableRooms = [];
        for (var i = 0; i < events.length; i++) {
          var evt = events[i];
          var req = evt.requiredUsers.find(val => {
            return (
              store.account.toUpperCase() == val.id.toUpperCase() ||
              store.mail.toUpperCase() == val.id.toUpperCase()
            );
          });
          var opt = evt.optionalUsers.find(val => {
            return (
              store.account.toUpperCase() == val.id.toUpperCase() ||
              store.mail.toUpperCase() == val.id.toUpperCase()
            );
          });
          evt.rooms = evt.rooms.filter(
            r => r.id != "" && r.status == status.accepted
          );
          // 必須出席者内で辞退していない、任意出席者で辞退していない、主催者である場合のみ表示する
          // イベントのルームがある&チェックアウトされていないもの＆終日予約でないものみを表示
          if (
            ((req && req.status != status.declined) ||
              (opt && opt.status != status.declined) ||
              (evt.organizer &&
                (evt.organizer.id.toUpperCase() ==
                  store.account.toUpperCase() ||
                  evt.organizer.id.toUpperCase() ==
                    store.mail.toUpperCase()))) &&
            evt.rooms &&
            evt.rooms.length &&
            !evt.checkouts.length &&
            !evt.isAllDay
          ) {
            evt.iWasCheckin = evt.checkins.includes(store.account);
            _this.checkinEnableRooms.push(evt);
          }
        }
        meetingIsLoaded = true;
        _this.loaded = meetingIsLoaded && roomsIsLoaded;
      });
    },
    selectedRoom: function(meeting) {
      var r = this.rooms.filter(
        r => meeting.rooms[0].address.toUpperCase() === r.address.toUpperCase()
      );
      this.$router.push({
        path: `/room/${r[0].id}`,
        query: { meeting: meeting.icalId }
      });
    }
  }
};
</script>

<style lang="scss">
/** メインコンテンツ **/
.home_main {
  width: 100%;
  height: calc(100% - 190px);
  overflow-y: auto;
  padding: 0px 8px 10px;
  box-sizing: border-box;
}
/** 予定リスト **/
.home_schedule {
  width: 100%;
}
.home_schedule_item {
  border-radius: 5px;
  margin-bottom: 14px;
  box-shadow: 1px 1px 5px 0px rgba(97, 79, 67, 0.5);
}
.home_schedule_item_a {
  width: 100%;
  display: flex;
}
/** リスト左 **/
.schedule_item_left {
  width: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px 0 0 5px;
  padding: 5px;
  box-sizing: border-box;
  color: #fff;
}
/** リスト右 **/
.schedule_item_right {
  width: calc(100% - 90px);
  background-color: #fff;
  border-radius: 0 5px 5px 0;
  padding: 10px;
  box-sizing: border-box;
  color: #333333;
}
.checkin-now .schedule_item_left {
  background-color: $btnColor;
}
.checkin-wait .schedule_item_left {
  background-color: #b7b7b7;
}
.item_left_icon {
  width: 38px;
}
.item_left_text {
  font-size: 11px;
  font-weight: bold;
  padding-top: 5px;
  box-sizing: border-box;
}
/** 予定なし **/
.home_no-schedule {
  width: 90%;
  display: flex;
  align-items: center;
  padding: 20px 16px;
  background-color: #fff;
  box-sizing: border-box;
  margin: 0 auto;
  box-shadow: 1px 1px 5px 0px rgba(97, 79, 67, 0.3);
  border-radius: 5px;
}
.no-schedule_icon {
  width: 60px;
}
.no-schedule_icon > img {
  width: 44px;
}
.no-schedule_text {
  width: calc(100% - 60px);
}
/** 下部ボタン **/
.home_bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 136px;
  display: flex;
  box-sizing: border-box;
}
.home_bottom_btn {
  position: relative;
  width: 80%;
  background-color: $btnColor;
  margin: 32px auto 20px;
}
.home_bottom_btn_link {
  display: flex;
  justify-content: center;
  height: 100%;
  position: relative;
  color: #fff;
}
.home_bottom_btn_icon {
  position: absolute;
  top: -32px;
  width: 64px;
  background-color: $btnColor;
  height: 64px;
  border-radius: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.home_bottom_btn_icon > img {
  width: 50px;
}
.home_bottom_btn_text {
  display: flex;
  align-items: flex-end;
  padding-bottom: 12px;
  text-align: center;
  line-height: 1.4;
}
</style>